import { useState, useEffect } from 'react';

export const useAudioPlayerModal = (audioId: string) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const closeModalAfterAudioPlayed = () => {
    const audio = document.getElementById(audioId);
    if (audio) {
      audio.addEventListener('ended', () => {
        setIsOpen(false);
      });
    }
  };

  useEffect(() => {
    closeModalAfterAudioPlayed();
  }, []);

  return {
    isOpen,
    toggle,
    closeModalAfterAudioPlayed,
  };
};
